import store from "../store/store.js";
import Home from "@/pages/Home";
import Login from "@/pages/Login.vue";
import Repair from "@/pages/Repair.vue";
import NotFoundPage from "@/pages/404.vue";

var routes = [
    {
        path: "/",
        async: function ({ app, to, resolve }) {
            const isLogined = store.state.auth.isLogined;

            // 判定時間位於 202409061600~202409061800
            // const now = new Date();
            // const year = now.getFullYear();
            // const start = new Date(year, 8, 6, 16, 0, 0);
            // const end = new Date(year, 8, 6, 18, 0, 0);

            // if (location.search.includes('mukiTest')) {
            //     localStorage.setItem('pass', 'true')
            // }

            // if (now > start && now < end && !localStorage.getItem('pass')) {
            //     // 超過時間
            //     resolve({
            //         component: Repair,
            //     });
            //     return;
            // }else{
                resolve({
                    component: Home,
                });
                return;
            // }


            // Requested route
            if (isLogined) {
                resolve({
                    component: Home,
                });
            } else {
                resolve({
                    component: Login,
                });
            }
        },
    },
    // 登入
    {
        path: "/login",
        asyncComponent: () => import("@/pages/Login"),
    },
    // 新增售服單
    {
        path: "/add_company/:serviceSaleID",
        asyncComponent: () => import("@/pages/AddCompany"),
    },
    // 編輯售服單
    {
        path: "/edit_company/:serviceSaleID",
        asyncComponent: () => import("@/pages/AddCompany"),
        options: {
            props: {
                isEdit: true,
            },
        },
    },
    // 售服單列表
    {
        path: "/company/:serviceSaleID",
        asyncComponent: () => import("@/pages/Company"),
    },
    // 新增售服單列表
    {
        path: "/add_service/:serviceSaleID",
        asyncComponent: () => import("@/pages/AddService"),
    },
    // 維修人員
    {
        path: "/maintenance_worker/:serviceSaleID",
        asyncComponent: () => import("@/pages/MaintenanceWorker"),
    },
    // 維修時間
    {
        path: "/maintenance_time/:serviceSaleID",
        asyncComponent: () => import("@/pages/MaintenanceTime"),
    },
    // 客戶確認
    {
        path: "/client_confirmation/:serviceSaleID",
        asyncComponent: () => import("@/pages/ClientConfirmation"),
    },
    // 機台資訊
    {
        path: "/machine/:serviceMachineID",
        asyncComponent: () => import("@/pages/Machine"),
    },
    // 機台功能
    {
        path: "/machine_function/:serviceMachineID",
        asyncComponent: () => import("@/pages/MachineFunction"),
    },
    // 組織排列
    {
        path: "/arrangement/:serviceMachineID",
        asyncComponent: () => import("@/pages/Arrangement"),
    },
    // 零配件
    {
        path: "/accessories/:serviceMachineID",
        asyncComponent: () => import("@/pages/Accessories"),
    },
    // 處理紀錄
    {
        path: "/operating_procedures/:serviceMachineID",
        asyncComponent: () => import("@/pages/OperatingProcedures"),
    },
    // 問題處理
    {
        path: "/problem_solving/:serviceMachineID",
        asyncComponent: () => import("@/pages/ProblemSolving"),
    },
    // 問題處理新增
    {
        path: "/add_problem_solving/:serviceMachineID",
        asyncComponent: () => import("@/pages/AddProblemSolving"),
    },
    // 問題處理紀錄
    {
        path: "/problem_solving_record/:id",
        asyncComponent: () => import("@/pages/ProblemSolvingRecord"),
    },
    // 受訓對象
    {
        path: "/course_students/:serviceMachineID",
        asyncComponent: () => import("@/pages/CourseStudents"),
    },
    // 課程計畫
    {
        path: "/course_plan/:serviceMachineID",
        asyncComponent: () => import("@/pages/CoursePlan"),
    },
    // 課程時程
    {
        path: "/course_time/:serviceMachineID",
        asyncComponent: () => import("@/pages/CourseTime"),
    },
    // MU機台調查
    {
        path: "/inquire",
        asyncComponent: () => import("@/pages/Inquire"),
    },
    // 新增機台調查
    {
        path: "/add_inquire/:MuID",
        asyncComponent: () => import("@/pages/AddInquire"),
    },
    // 編輯機台調查
    {
        path: "/edit_inquire/:MuID",
        asyncComponent: () => import("@/pages/AddInquire"),
        options: {
            props: {
                isEdit: true,
            },
        },
    },
    // 紡織設備
    {
        path: "/inquire_equipment/:MuID",
        asyncComponent: () => import("@/pages/InquireEquipment"),
    },
    // 紡織機廠牌
    {
        path: "/inquire_brand/:MuID",
        asyncComponent: () => import("@/pages/InquireBrand"),
    },
    // 紡織機類型
    {
        path: "/inquire_type/:MuID",
        asyncComponent: () => import("@/pages/InquireType"),
    },
    // {
    //     path: "/forgot_pwd",
    //     asyncComponent: () => import("@/pages/ForgotPwd"),
    // },
    // {
    //     path: "/forgot_pwd_reset",
    //     asyncComponent: () => import("@/pages/ForgotPwdReset"),
    // },
    {
        path: "(.*)",
        component: NotFoundPage,
    },
];

export default routes;
